// The watchlist's star (SCENARIOS E5, PLAN-2026-10-03-research-tools.md §10):
// beside a player's name on a Players row and on his card. One tap. Outlined
// when off and filled when on, so it reads without color, and said as a
// toggle to a screen reader.
//
// Its own button inside a row that opens the card, so it stops the row's tap.
// A real league's only: the tour's simulator has no account to keep a list on.

import { useLeagueSource } from '../../data/leagueSource';
import { useWatchlist } from '../../data/watchlist';
import { Icon } from '../../kit/Icon';

export function WatchStar({
  player,
  fallback = false,
}: {
  player: { id: string; name: string };
  /** The row's own `watched`, the answer until the account's list is read. */
  fallback?: boolean;
}) {
  const real = useLeagueSource() === 'api';
  const list = useWatchlist();
  if (!real || list.toggle === null) return null;
  const on = list.watching(player.id, fallback);
  const toggle = list.toggle;
  return (
    <button
      type="button"
      className="fsp-watch-star"
      data-on={on || undefined}
      aria-pressed={on}
      aria-label={`Watch ${player.name}`}
      title={on ? 'On your watchlist' : 'Add to your watchlist'}
      onClick={(e) => {
        e.stopPropagation();
        toggle(player.id, !on);
      }}
    >
      <Icon name={on ? 'favorited' : 'favorite'} size="sm" />
    </button>
  );
}
